<div class="displayLibsCenter" fxFlex="33"
     fxLayout="column" fxLayoutAlign="center center">

  <app-register [successLink]="'confirm'"
                [apiEndpoint]="'https://api.dev.ecomm-sites.letha-local.co.za/user-mgt/users/v1'"
                [returnLink]="'login'"
                [isAnAdminUser]="false"
                [showAddressFields]="true"
                [adrressHeader]="'Complete Address'"
                [imageSrc]="'../../../assets/logos/saCentre.png'">
  </app-register>
</div>
